import HttpService from "./http.service";
class ChangeLogService {

    // Create a new changeLog entry
    createChangeLog = async (changeLog) => {
        const endpoint = 'changelog';
        return await HttpService.post(endpoint, changeLog);
    };

    // Add change to an existing changeLog entry
    addChange = async (change) => {
        const endpoint = 'changelog';
        return await HttpService.patch(endpoint, change);
    }

    // Get a changeLog entry
    getPartCodeChangeLog = async (id) => {
        const endpoint = `changelog/${id}`;
        return await HttpService.get(endpoint);
    }
    /*
    getPartCatChangeLog = async (id) => {
        const endpoint = `changelog/${id}`;
        return await HttpService.get(endpoint);
    }*/

    getDocumentChanges = async (type, id) => {
        const endpoint = `changelog/doc/${type}/${id}`;
        return await HttpService.get(endpoint);
    }

    // Get changes by document type
    getTypeChanges = async (type, limit) => {
        const endpoint = `changelog/bytype?type=${type}&limit=${limit}`;
        return await HttpService.get(endpoint);
    }
}

export default new ChangeLogService();